import React from 'react';
import {
  Recommendations,
} from '@xp-utilities/web';
import AddToBagInstrumentationsContext from '../../contexts/AddToBagInstrumentationsContext';

const recommendationsProps = {
  clientId: 'addToBag-1',
  placements: [
    'add_to_cart_page.rr1',
    'add_to_cart_page.rr2',
    'add_to_cart_page.rr3',
    'add_to_cart_page.rr4',
    'add_to_cart_page.rr5',
    'add_to_cart_page.rr6',
  ],
};

export default function AddToBagInstrumentation() {
  return (
    <AddToBagInstrumentationsContext id={recommendationsProps.clientId}>
      <div
        id={recommendationsProps.clientId}
        data-testid={recommendationsProps.clientId}
      >
        <Recommendations placements={recommendationsProps.placements} />
      </div>
    </AddToBagInstrumentationsContext>
  );
}
